import { EMPTY_OBJECT } from '../../../constants/common'
import { getVisibleFilters } from '../../../utils/filter'
import { isSubArchive } from '../../../utils/route'

import {
  ENTITY_TAB_REQUESTS_SCALAR_SCOPE_FILTER_KEYS,
  ENTITY_TAB_REQUESTS_SUB_TAB_ORDER,
  ENTITY_TAB_REQUESTS_SUB_TAB_QA_NAME,
  ENTITY_TAB_REQUESTS_SUB_TAB_TEXT_KEY,
} from './EntityTabRequests.constants'

export function hasEntityTabRequestsItems(requests) {
  return requests?.items?.length > 0
}

export function hasEntityTabRequestsVisibleFilters(availableFilters) {
  return getVisibleFilters(availableFilters).length > 0
}

export function isEntityTabRequestsToolbarCollapsed({
  hasFilterChanged,
  hasRequests,
  hasVisibleFilters,
  isLoading,
  shouldShowCreateButton,
}) {
  return (
    !isLoading &&
    ((!hasRequests && !hasFilterChanged) ||
      (!hasVisibleFilters && !shouldShowCreateButton))
  )
}

export function getEntityTabRequestsScopeFilter({ scopeFilterKey, scopeId }) {
  return {
    [scopeFilterKey]: ENTITY_TAB_REQUESTS_SCALAR_SCOPE_FILTER_KEYS.includes(
      scopeFilterKey
    )
      ? scopeId
      : [scopeId],
  }
}

export function getEntityTabRequestsExtraFilters({
  activeSubTab,
  scopeFilterKey,
  scopeId,
}) {
  return {
    ...(isSubArchive(activeSubTab) ? { archived: true } : null),
    ...getEntityTabRequestsScopeFilter({ scopeFilterKey, scopeId }),
    sub_menu: activeSubTab,
  }
}

export function getEntityTabRequestsSubTabItems({
  counters,
  subTabOrder = ENTITY_TAB_REQUESTS_SUB_TAB_ORDER,
  t,
}) {
  return subTabOrder.map(value => {
    const subTabCounters = counters?.[value] || EMPTY_OBJECT

    return {
      count: subTabCounters.total ?? null,
      text: t(ENTITY_TAB_REQUESTS_SUB_TAB_TEXT_KEY[value]),
      unread: subTabCounters.unread ?? null,
      value,
    }
  })
}

export function getEntityTabRequestsSubTabQaName(item) {
  return ENTITY_TAB_REQUESTS_SUB_TAB_QA_NAME[item.value]
}
